'use client';

import { activate } from '@zeus/core';

// https://mui.com/x/introduction/licensing/#next-js-app-router
activate();

export const License = () => null;
